import React, { useState, useEffect, useMemo } from "react"
import { useSelector } from "react-redux"
import Tables from "../../../../Reuseable/Tables"
import "react-confirm-alert/src/react-confirm-alert.css"
import MydashboardModalView from "./style"
import moment from "moment"
import DoughnutChart from "./ProjectDoughnut"
import { ProjectDashboradBarChart } from "./ProjectDashboradBarChart"
import ProjectEditableComponents from "./ProjectEditableComponents"
import { ProjectVersions } from "./ProjectVersions"
import UIModal from "../../../../Reuseable/Modal"
import { ProjectTaskList } from "./ProjectTaskList"
import ProjectMyTeam from "./ProjectMyTeam"
import { useFetch } from "../../../../../Hooks/useFetch"
import { key } from "../../../../../data/queryKeys"
import { Row, Col, Card, Select } from "antd";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import TaskBugChart from "../../../Chart/TaskBugChart"
import StatusSummaryChart from "../../../Chart/StatusSummaryChart "
const { Option } = Select;

export default function ProjectDashboard({
  showProject,
  setShowProject,
  permission,
  datas,
  version,
  allProjects,
  projectTaskList,
  loading
}) {

  let data = datas
  // const editPermission = permission?.edit
  // const createPermission = permission?.create
  // const deletePermission = permission.delete
  // const viewPermission = permission.view

  const authToken = useSelector((state) => state.Auth.authToken)
  const trackingClientId = useSelector((state) => state.Auth.user.trackingclientid)

  let allProjectDashboard = useSelector((state) => state.Tracking.allProjectDashboard)

  // Get all trackings data from Redux store (same as in Tracking component)
  let allTrackingsList = useSelector((state) => state.Tracking.allTrackings)

  const [filteredTasks, setFilteredTasks] = useState([])
  const [showTaskCountsModal, setShowTaskCountsModal] = useState(false)
  const [showTaskStatus, setShowTaskStatus] = useState("")

  // Debug modal state changes
  useEffect(() => {
  }, [showTaskCountsModal, showTaskStatus, filteredTasks])

  let projectNow = allProjects?.find((item) => item.trackingprojectid === data)

  const index = allProjects?.findIndex(
    (element) => element.trackingprojectid === projectNow?.trackingprojectid
  )

  const { data: allProjectWorkflowRes } = useFetch(
    key.get_all_workflow,
    `/trekrworkflow`,
    () => { },
    () => { },
    false,
    false
  )
  let allWorkFlow = allProjectWorkflowRes?.data?.workflowList ?? []

  const { data: allMembersRes } = useFetch(
    key.get_all_members,
    `/trackingusers/memberlist/${trackingClientId}`,
    () => { },
    () => { },
    false,
    false
  )
  let allMembers = allMembersRes?.data ?? []

  let convertedMonthTypeCounts = {}

  allProjectDashboard !== "" &&
    allProjectDashboard &&
    Object.keys(allProjectDashboard?.monthTypeCounts || {})?.forEach((month) => {
      const convertedCounts = {}

      allProjectDashboard !== "" &&
        allProjectDashboard &&
        Object.keys(allProjectDashboard?.monthTypeCounts[month] || {}).forEach((key) => {
          let convertedKey = ""

          switch (key) {
            case "1":
              convertedKey = "Bug/Issue"
              break
            case "2":
              convertedKey = "New Task"
              break
            case "3":
              convertedKey = "Request for Change"
              break
            case "4":
              convertedKey = "Other"
              break
            default:
              convertedKey = "Unknown"
              break
          }

          convertedCounts[convertedKey] = allProjectDashboard.monthTypeCounts[month][key]
        })

      convertedMonthTypeCounts[month] = convertedCounts
    })

  const priorityCount = allProjectDashboard?.priorityCount
  const Work_Flow1 = allWorkFlow && Object.values(allWorkFlow).flatMap((obj) => Object.values(obj))

  // Get workflow for current project
  let workflow_status = Work_Flow1?.find((e) => e.workFlowId === projectNow?.workflow)
  const statusName = workflow_status?.workFlow

  // Create a proper workflow mapping object
  let workflowName = {}
  if (statusName) {
    Object.keys(statusName).forEach(key => {
      const statusData = statusName[key]
      if (statusData && typeof statusData === 'object') {
        workflowName[key] = statusData
      }
    })
  }

  // Calculate priority counts from projectTaskList (tracking/trackingproject endpoint)
  let priorityCountFromProjectTasks = {}

  if (projectTaskList && projectTaskList.length > 0) {

    const priorityCounts = {}
    projectTaskList.forEach(task => {
      const priority = task.priority
      if (priority) {
        // Map priority values to readable names
        let priorityName = priority
        if (priority === "blocker") {
          priorityName = "Blocker Level 1"
        } else if (priority === "blocker2") {
          priorityName = "Blocker Level 2"
        } else if (priority === "major") {
          priorityName = "Major"
        } else if (priority === "medium") {
          priorityName = "Medium"
        } else if (priority === "minor") {
          priorityName = "Minor"
        }

        priorityCounts[priorityName] = (priorityCounts[priorityName] || 0) + 1
      }
    })

    priorityCountFromProjectTasks = priorityCounts
  }

  // Use only projectTaskList priority count
  const finalPriorityCount = priorityCountFromProjectTasks

  // Calculate task status counts from projectTaskList (tracking/trackingproject endpoint)
  let statusTaskCount = []

  if (projectTaskList && projectTaskList.length > 0) {
    // Count tasks by status from projectTaskList
    const statusCounts = {}
    projectTaskList.forEach(task => {
      const statusId = task.trackingprojectstatusid
      if (statusId) {
        statusCounts[statusId] = (statusCounts[statusId] || 0) + 1
      }
    })

    // Only include statuses that have tasks (value > 0)
    const statusesWithTasks = Object.keys(statusCounts).filter(statusId => statusCounts[statusId] > 0)

    if (statusesWithTasks.length > 0) {
      // Create status count array only for statuses with tasks
      statusTaskCount = statusesWithTasks.map(statusId => ({
        name: statusId,
        value: statusCounts[statusId]
      }))
    } else {
      // No tasks found, show single "Tasks" card with 0
      statusTaskCount = [{
        name: "1",
        value: 0
      }]
    }
  } else {
    statusTaskCount = [{
      name: "1",
      value: 0
    }]
  }

  let versiondata = statusTaskCount
    ?.sort((a, b) => parseInt(a.name) - parseInt(b.name))
    .map((item) => {
      let myYdata = workflowName?.[item?.name]
      let newY = ""

      // Try to get status name from workflow mapping
      if (myYdata) {
        if (typeof myYdata === 'string') {
          newY = myYdata
        } else if (typeof myYdata === 'object') {
          // If it's an object, try to get the first value
          const values = Object.values(myYdata)
          if (values.length > 0) {
            newY = values[0]?.toString() || ""
          }
        }
      }

      // If workflow mapping fails, use a fallback name
      if (!newY) {
        // If this is the only card and has 0 value, show "Tasks"
        if (statusTaskCount.length === 1 && item.value === 0) {
          newY = "Tasks"
        } else {
          // Try to get status name from workflow_status directly
          const directStatus = statusName?.[item?.name]
          if (directStatus && typeof directStatus === 'object') {
            const directValues = Object.values(directStatus)
            if (directValues.length > 0) {
              newY = directValues[0]?.toString() || ""
            }
          }

          // If still no name, use generic status name
          if (!newY) {
            newY = `Status ${item.name}`
          }
        }
      }

      return { name: newY, value: item.value, id: item.name }
    })
  const getTableData = projectNow?.teammates?.map((item, i) => {
    let hex = Math.floor(Math.random() * 0xffffff)
    let color = "#" + hex.toString(16)

    return (
      <tr key={i} val={item}>
        <td>
          <div className='d-flex align-items-center'>
            <div className='team-name-circle' style={{ background: color }}>
              <span>{item.label[0]}</span>
            </div>
            <div className='ms-2'>{item.label}</div>
          </div>
        </td>
      </tr>
    )
  })

  const taskColumns = (
    <>
      <th className='text-nowrap' style={{ minWidth: '120px' }}>
        <span className='ps-1'>Task No</span>
      </th>
      <th className='text-nowrap' style={{ minWidth: '200px' }}>Title</th>
      <th className='text-nowrap d-none d-md-table-cell' style={{ minWidth: '100px' }}>Timeline</th>
      <th className='text-nowrap d-none d-lg-table-cell' style={{ minWidth: '150px' }}>Reported On</th>
      <th className='text-nowrap d-none d-lg-table-cell' style={{ minWidth: '120px' }}>Reported By</th>
      <th className='text-nowrap d-none d-xl-table-cell' style={{ minWidth: '120px' }}>Assigned To</th>
      <th className='text-nowrap' style={{ minWidth: '100px' }}>Priority</th>
    </>
  )

  const openTaskModal = (id) => {

    let filtered = () => {
      // Use only projectTaskList (tracking/trackingproject endpoint)
      let projectTasks = projectTaskList.filter(task =>
      (task.trackingprojectstatusid === id ||
        task.trackingprojectstatusid === parseInt(id) ||
        task.trackingprojectstatusid === id.toString())
      )

      return projectTasks
        .map((item, i) => {
          let reportedby = allMembers
            .filter((member) => member.userId === item.reportedby)
            .map((member) => member.personname)
            .join(", ")

          let assignedTo = allMembers
            .filter((member) => member.userId === item.assignedto)
            .map((member) => member.personname)
            .join(", ")

          if (assignedTo === "" || assignedTo === "-") {
            assignedTo = "Not Assigned"
          }

          return (
            <tr key={i} val={item}>
              <td className='text-nowrap'>
                <span>
                  {item.trackingclientid}-{item.trackingid}
                </span>
              </td>
              <td>
                <span style={{ wordWrap: 'break-word', whiteSpace: 'normal', maxWidth: '200px' }}>{item?.title}</span>
              </td>
              <td className='text-capitalize text-nowrap d-none d-md-table-cell'>
                <span>{item.timeline === "" ? "-" : item.timeline}</span>
              </td>
              <td className='text-capitalize text-nowrap d-none d-lg-table-cell'>
                <span>
                  {item.reporteddate === ""
                    ? "-"
                    : moment(item.reporteddate).format("MMM D, YYYY hh:mm A")}
                </span>
              </td>
              <td className='text-capitalize text-nowrap d-none d-lg-table-cell'>
                <span>{reportedby}</span>
              </td>
              <td className='text-capitalize text-nowrap d-none d-xl-table-cell'>
                <span>{assignedTo}</span>
              </td>
              <td className='text-nowrap'>
                <span className='text-capitalize'>
                  {item.priority === "blocker"
                    ? "Blocker Level 1"
                    : item.priority === "blocker2"
                      ? "Blocker Level 2"
                      : item.priority === ""
                        ? "-"
                        : item.priority}
                </span>
              </td>
            </tr>
          )
        })
    }
    setFilteredTasks(filtered)
    setShowTaskCountsModal(true)
  }

  //    const handleFilterChange = (filters) => {
  //     console.log("User selected filters:", filters);
  //     // optionally trigger API or analytics event here
  //   };

  return (
    <>
      <MydashboardModalView>
        {loading ? (
          <></>
        ) : (
          <>
            {version === "Dashboard" ? (
              <>
                <Row className='align-items-center mb-3 ms-0 total_chart_container'>
                  <div className='p-3 bar_chart_container'>
                    <div>
                      <ProjectDashboradBarChart
                        convertedMonthTypeCounts={convertedMonthTypeCounts}
                        monthTypeCounts={allProjectDashboard.monthTypeCounts}
                        allTrackingsList={allTrackingsList}
                        projectTaskList={projectTaskList}
                        projectNow={projectNow}
                      />
                    </div>
                  </div>
                  <div className='doughnut_chart'>
                    <DoughnutChart
                      priorityCount={finalPriorityCount}
                      allProjectDashboard={allProjectDashboard}
                    />
                  </div>
                </Row>
                <Row gutter={24}>
                  <Col span={12}>
                    <TaskBugChart
                      projectId={datas}
                    />
                  </Col>
                  <Col span={12}>
                    <StatusSummaryChart
                      projectId={datas}
                    />
                  </Col>
                </Row>

                {(() => {
                  return versiondata?.length > 0 ? (
                    <>
                      <h5 className='project_sub_head'>Task Statuses</h5>
                      <div className='task_status'>
                        {versiondata?.map((item, i) => {
                          return (
                            <div className=' mb-3' key={i}>
                              <div
                                className='project_card p-3'
                                onClick={() => {
                                  openTaskModal(item.id)
                                  setShowTaskStatus(item.name)
                                }}
                                style={{ cursor: 'pointer' }}
                              >
                                <p className='mt-1'>{item.name}</p>
                                <h1 className='mb-0'>{item.value}</h1>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    </>
                  ) : (
                    <div style={{ padding: '10px', background: '#f0f0f0', margin: '10px 0', borderRadius: '5px' }}>
                      <p>No task status data available. Check console for debug info.</p>
                    </div>
                  )
                })()}

                <ProjectEditableComponents
                  showProject={showProject}
                  permission={permission}
                  datas={datas}
                  allProjects={allProjects}
                />
                <ProjectMyTeam
                  showProject={showProject}
                  setShowProject={setShowProject}
                  permission={permission}
                  datas
                  projectNow={projectNow}
                  allProjects={allProjects}
                />

                <br></br>
              </>
            ) : version === "List" ? (
              <>
                <ProjectTaskList projectTaskList={projectTaskList} loading={loading} />
              </>
            ) : (
              <ProjectVersions data={getTableData} projectNow={projectNow} />
            )}
          </>
        )}
        <UIModal
          className='project_dashboard_modal'
          title={`${showTaskStatus} Tasks`}
          showModal={showTaskCountsModal}
          setShowModal={setShowTaskCountsModal}
          size={"xl"}
        >
          <div className="responsive-table-container" style={{
            maxWidth: '100%',
            overflowX: 'auto',
            overflowY: 'auto',
            maxHeight: '70vh'
          }}>
            <Tables
              setProjectTable={true}
              columns={taskColumns}
              data={filteredTasks}
              showInfiniteScroll={false}
              notfound={"No Tasks Found"}
              loading={loading}
            />
          </div>
        </UIModal>
      </MydashboardModalView>
    </>
  )
}
